<script setup lang="ts">
import BaseSmallButton from './BaseSmallButton.vue'

defineProps<{
  isOpen: boolean
  title?: string
  confirmText?: string
  cancelText?: string
  disabled?: boolean
}>()

const emit = defineEmits<{
  (e: 'close'): void
  (e: 'confirm'): void
}>()
</script>

<template>
  <Teleport to="body">
    <div v-if="isOpen" class="modal-overlay" @click="emit('close')">
      <div class="modal-content" @click.stop>
        <div class="modal-header">
          <h2 class="title-sm white">{{ title }}</h2>
        </div>
        <div class="modal-body">
          <slot></slot>
        </div>
        <div class="modal-footer">
          <BaseSmallButton v-if="cancelText" :text="cancelText" type="sub" @click="emit('close')" />
          <BaseSmallButton
            v-if="confirmText"
            :text="confirmText"
            type="main"
            :disabled="disabled"
            @click="emit('confirm')"
          />
        </div>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.modal-content {
  background: var(--gray-900);
  padding: 20px;
  border-radius: 8px;
  min-width: 335px;
  max-width: 340px;
  max-height: 90vh;
  overflow-y: auto;
}

.modal-header {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-bottom: 12px;
}

.modal-body {
  margin-bottom: 8px;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.btn-primary {
  background-color: var(--primary);
  color: white;
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

.btn-secondary {
  background-color: var(--gray-200);
  color: var(--gray-700);
  padding: 8px 16px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
}

@media (max-width: 1365px) {
  .modal-footer {
    gap: 7px;
  }
}
</style>
